import React from "react";
import "./style.scss";
import logo from "../../assets/images/openLogo.svg";
import {useTranslation} from "react-i18next";
import HeaderMenuCategories from "./Categories";
import HeaderMenuSubCategories from "./SubCategories";
import orderStore from "../../stores/order";
import { useNavigate } from "react-router";
import config from "../../config/default.json";
import { getHost } from "../../helpers/ApiHelper";
import { observer } from "mobx-react";
import { ReactComponent as IconPerson } from "../../assets/icons/person.svg";
import LanguageBlock from "../LanguageBlock";
import useLayoutStyles from "../../hooks/styles";


const HeaderMenu = () => {
    let timerId: NodeJS.Timeout | null = null;
    let clickCount = 0;

    const [t] = useTranslation();
    const navigate = useNavigate();
    const styles = useLayoutStyles();

    const cancelOrder = async () => {
        await orderStore.cancelOrder();
        navigate("/");
    }

    const logoClick = () => {
        clickCount++;
        if (clickCount >= config.other.clickCount) {
            navigate("/settings");
        }

        if (!timerId) {
            timerId = setTimeout(() => {
                clickCount = 0;
                timerId = null;
            }, config.other.settingsClickTimer);
        }
    }

    return <div className="HeaderMenu">
        <div className="top">
            <img className="logo" src={styles?.general.logoImage ? `${getHost()}${styles.general.logoImage}` : logo} alt={t("companyName")} onClick={logoClick} />
            <div className="categories">
                <HeaderMenuCategories />
            </div>
            <LanguageBlock />
        </div>
        <div className="bottom">
            {orderStore.customer?.name || orderStore.internalCardObj?.cardNumber
                ? <div className="customer">
                    <IconPerson /> {orderStore.customer?.name || orderStore.internalCardObj?.cardNumber || ""}
                </div>
                : <div />
            }
            <div className="subCategories">
                <HeaderMenuSubCategories />
            </div>
            <div className="cancel" onClick={cancelOrder}>
                {t("cancelOrder")}
            </div>
        </div>
    </div>
}

export default observer(HeaderMenu);
